import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { SvgArrowLeftRight, SecondaryBtn } from '@tmapy/style-guide';
import { actionActivateReverseLineTool, actionDeactivateTools } from '../actions';
export const ReverseLineToolBtn = ({ isActive, dispatch, children, }) => {
    const handleClick = useCallback(() => {
        if (isActive) {
            dispatch(actionDeactivateTools());
        }
        else {
            dispatch(actionActivateReverseLineTool());
        }
    }, [dispatch, isActive]);
    return (_jsx(SecondaryBtn, { icon: { element: _jsx(SvgArrowLeftRight, {}) }, isActive: isActive, tooltip: children, onClick: handleClick }));
};
//# sourceMappingURL=ReverseLineToolBtn.js.map